import React, { useEffect, useState } from "react";
import { Button, Modal, Select, message, Alert, Spin } from "antd";

const AGENT = "http://localhost:3210";

export default function WorkDriveUI({openFolderDir, folderInfo, rootDirName}) {
  const [loading, setLoading] = useState(false);
  const [driveModal, setDriveModal] = useState(false);
  const [openFailCount, setOpenFailCount] = useState(0);
  const [selectedDrive, setSelectedDrive] = useState(null);
  const [installModal, setInstallModal] = useState(false);

  const checkAgent = async () => {
    try {
      const res = await fetch(`${AGENT}/ping`);
      return res.ok;
    } catch {
      return false;
    }
  };

  const getConfig = async () => {
    const res = await fetch(`${AGENT}/config`);
    return res.json();
  };

  const setDrive = async (drive) => {debugger
    const res = await fetch(`${AGENT}/set-root`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ drive })
    });
    debugger
    console.log("RESPONSE:", res);
    const data = await res.json();

    if (!res.ok) {
      throw new Error(data.error || "Failed to set drive");
    }

    return data;
  };

  const openFolder = async (path) => {
    const res = await fetch(`${AGENT}/open`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        relativePath: path
      })
    });

    const data = await res.json();
    // ERROR HANDLING
    if (!res.ok) {
      setOpenFailCount(prev => prev + 1);
      switch (data.error) {

        case "Root not set":
          message.warning("WorkDrive location not configured. Please select your drive.");
          setDriveModal(true);
          break;

        case "Root drive missing":
          message.warning("Your WorkDrive drive was changed or removed. Please select the correct drive again.",4);
          setDriveModal(true);
          break;

        case "Folder not found":
            if (openFailCount + 1 >= 3) {
              Modal.confirm({
                title: "WorkDrive issue detected",
                content:
                  "We couldn't locate your WorkDrive folder multiple times. Do you want to change the drive?",
                okText: "Change Drive",
                cancelText: "Cancel",
                onOk: () => setDriveModal(true)
              });
            } else {
              message.error("Folder not found in WorkDrive.");
            }
          break;

        case "Forbidden":
          message.error("Access denied. The folder is outside your WorkDrive root.");
          break;

        case "Not a folder":
          message.warning("You selected a file, not a folder. Please select a folder to open.");
          break;

        case "Path required":
          message.warning("No folder path provided.");
          break;

        default:
          message.error(data.error || "Failed to open folder");
      }
      return;
    }
    message.success("Folder opened successfully in File Explorer");
  };

  const handleClick = async (path) => {
    setLoading(true); 
    try {
      const isRunning = await checkAgent(); 
      if (!isRunning) {
        setInstallModal(true);
        return;
      } 
      const config = await getConfig(); 
      if (!config.root) {
        setDriveModal(true);
        return;
      } 
      await openFolder(path); 
    } catch (err) {
      message.error("Unexpected error occurred");
    } finally {
      setLoading(false);
    }
  };
  function createPath(dir,current){
    let init = rootDirName;
     let sec = dir.map(one=>one.name).join("/");
    return init+"/"+sec+"/"+current;
  }
  useEffect(()=>{
    debugger
    if(folderInfo.name){
      let path=createPath(openFolderDir,folderInfo.name);
      handleClick(path);
    }
  },[folderInfo])
  const downloadAgent = () => {
    window.open("/app/WorkDriveAgentSetup.exe");
    setInstallModal(false);
    message.success({content: "Install the agent and try again.", key: "submit", duration: 2});
    message.warning({content: "As it's a local agent and not a full app, it may give warnings from windows security, kindly ignore and run the app", key: "submit", duration: 5});
  };

  const confirmDrive = async () => {
    if (!selectedDrive) {
      message.warning("Please select a drive first");
      return;
    }
    try {
      await setDrive(selectedDrive);
      setOpenFailCount(0);
      setDriveModal(false);
      message.success("WorkDrive configured successfully");
    } catch (err) {
      message.error(err.message);
    }
  };

  return (
    <div>
      {/* <Button
        type="primary"
        onClick={handleClick}
        loading={loading}
      >
        Open WorkDrive Folder
      </Button> */}

      {loading && (
        <div style={{ marginTop: 10 }}>
          <Spin /> Checking agent & opening folder...
        </div>
      )}

      <Modal
        open={installModal}
        title="Agent Required"
        onCancel={() => setInstallModal(false)}
        footer={[
          <Button key="cancel" onClick={() => setInstallModal(false)}>
            Cancel
          </Button>,
          <Button key="download" type="primary" onClick={downloadAgent}>
            Download Agent
          </Button>
        ]}
      >
        <Alert
          type="info"
          message="To access your local WorkDrive folders, you need to install the desktop agent."
          showIcon
        />
      </Modal>

      <Modal
        open={driveModal}
        title="Select WorkDrive Location"
        onCancel={() => setDriveModal(false)}
        footer={[
          <Button key="cancel" onClick={() => setDriveModal(false)}>
            Cancel
          </Button>,
          <Button key="confirm" type="primary" onClick={confirmDrive}>
            Confirm
          </Button>
        ]}
      >
        <Alert
          type="warning"
          message="We couldn't find your WorkDrive root. Please select the drive where it is installed."
          style={{ marginBottom: 10 }}
        />

        <Select
          style={{ width: "100%" }}
          placeholder="Select drive (e.g. Z:)"
          value={selectedDrive}
          onChange={setSelectedDrive}
        >
          {["Z:", "Y:", "X:", "W:", "V:", "U:", "T:", "S:", "D:", "C:"].map(d => (
            <Select.Option key={d} value={d}>
              {d}
            </Select.Option>
          ))}
        </Select>
      </Modal>

    </div>
  );
}